<div class="insets background center">
    <img alt="outreach logo" 
        src="../../assets/Images/LogoWordsWhite.png" 
    />

    <mat-horizontal-stepper [linear]="false" #stepper>
        <mat-step >
        <ng-template matStepLabel>Login To Outreach</ng-template>
        <div class="center">
        <mat-form-field>
            <mat-label>Email</mat-label>
            <input matInput id='oer'  type='email' name='email' placeholder="Outreach Email" [(ngModel)]="email"><br>
        </mat-form-field>
        <br/>
        <mat-form-field>
            <mat-label>Password</mat-label>
            <input id="ppr"  matInput type="password" name="pword" placeholder="Outreach Password" [(ngModel)]="password"><br>
        </mat-form-field>
        <div>
            <button  mat-raised-button (click)=login(stepper)>{{loginMessage}}</button>
        </div>
        </div>

        </mat-step>
        <mat-step label="Choose your org to link">
            <h6>Choose an Org below to link :</h6>
            <div 
                *ngFor="let org of orgs" 
                [ngClass]="{'selected' : org?.id === selectedOrg?.id, 'org': true}"
                (click)=setSelectedOrg(org)
                >
                <h3>{{org.name}}</h3>
            </div>
            <div class="_row">
              <button mat-raised-button matStepperPrevious>Back</button>
              <button mat-raised-button matStepperNext>Next</button>
            </div>
        </mat-step>
        <mat-step>
          <ng-template matStepLabel>Done</ng-template>
          <p>You are now done.</p>
          <div>
            <button mat-button matStepperPrevious>Back</button>
            <button mat-button (click)="stepper.reset()">Reset</button>
          </div>
        </mat-step>
      </mat-horizontal-stepper>    
</div>


